/* global axios */
import ApiClient from './ApiClient';

class SaasBillingAPI extends ApiClient {
  constructor() {
    super('saas_subscription', { accountScoped: true });
  }

  getSubscription() {
    return axios.get(this.url);
  }

  createPayment({ planId, months, paypalOrderId }) {
    return axios.post(this.url.replace('saas_subscription', 'saas_payments'), {
      plan_id: planId,
      months,
      paypal_order_id: paypalOrderId,
    });
  }
}

export const getPaypalClientId = () => {
  return axios.get('/api/v1/saas_config');
};

export default new SaasBillingAPI();
